import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import Country from '@/data/models/domain/Country'

@OrmModel(modelNames.NUMBER_AVAILABLE_COUNTRY)
export default class NumberAvailableCountry extends Country {}
